import { Language } from '../../common/types/i18n.js'
import { View } from '../types.js'

const STORAGE_KEY = 'portal-lang'

const isLanguage = (value: string | null): value is Language => value === 'et' || value === 'en'

/** The language to start the session in: the persisted choice, else Estonian. */
export const loadInitialLanguage = (): Language => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY)
        return isLanguage(stored) ? stored : 'et'
    } catch {
        return 'et'
    }
}

/**
 * The current UI language as last persisted. Mirrors `loadInitialLanguage` —
 * `setLanguage` always writes the same key synchronously, so localStorage is the
 * live source of truth. Used outside React (e.g. the API client) where the
 * `view` state isn't in scope.
 */
export const getCurrentLanguage = (): Language => loadInitialLanguage()

/** Set the UI language, persist it across reloads, and re-render. */
export const setLanguage = (view: View, lang: Language): void => {
    view.state.lang = lang
    try {
        localStorage.setItem(STORAGE_KEY, lang)
    } catch {
        // localStorage can be unavailable (private mode / quota): the language
        // still changes for this session, it just won't survive a reload.
    }
    view.update()
}
